import React, { useEffect, useRef, useState} from 'react';
import * as d3 from 'd3';

export interface MyComponentProps {
  // Define your prop types here
  resourceid: any,
  onNodeClick?: any,
  resourceType?: string // item or default to block
}


export const NodeCommunities: React.FC<MyComponentProps> = (props) => {
  const [communities, setCommunities] = useState<any[]>([]);
  const [itemToCommunity, setItemToCommunity] = useState<any>({});
  const [edges, setEdges] = useState<any[]>([]);
  const [filteredEdges, setFilteredEdges] = useState([]);
  const prevFilteredEdges = useRef(filteredEdges);
  const [stringToNumberMap, setStringToNumberMap] = useState<{ [key: string]: number }>({});
  const [numberToStringMap, setNumberToStringMap] = useState<{ [key: number]: string }>({});
  const svgRef = useRef(null);

  useEffect(() => {
    // Fetch communities.json
    //const communitiesFileName = props.resourceType === "item" ? "./communities2.json" : "./communities-2025-02-10.json"
    const communitiesFileName = props.resourceType === "item" ? "./communities2.json" : "https://gist.githubusercontent.com/jeffreycwitt/87fea4d50fda32e64d9801b2b6010232/raw/communities.json"
    fetch(communitiesFileName)
      .then(response => response.json())
      .then(data => setCommunities(data))
      .catch(error => console.error('Error loading communities:', error));

    // Fetch item_to_community.json
    //const itemToCommunitiesFileName = props.resourceType === "item" ? "./item_to_community2.json" : "./item_to_community-2025-02-10.json"
    const itemToCommunitiesFileName = props.resourceType === "item" ? "./item_to_community2.json" : "https://gist.githubusercontent.com/jeffreycwitt/69e6ba78ca5d24e3d6174826e8c46d6c/raw/item_to_community.json"
    
    fetch(itemToCommunitiesFileName)
      .then(response => response.json())
      .then(data => setItemToCommunity(data))
      .catch(error => console.error('Error loading item_to_community:', error));

      // Fetch item_to_community.json
    //const edgesFileName = props.resourceType === "item" ? "./edges2.json" : "./edges-2025-02-10.json"
    const edgesFileName = props.resourceType === "item" ? "./edges2.json" : "https://gist.githubusercontent.com/jeffreycwitt/887fa58a0d40115caa267c19ce2eb16e/raw/edges.json"
    
    fetch(edgesFileName)
      .then(response => response.json())
      .then(data => setEdges(data))
      .catch(error => console.error('Error loading item_to_community:', error));
  }, []);

  useEffect(() => {
    if (edges.length > 0 && communities.length > 0 && Object.keys(itemToCommunity).length > 0) {
      setStringToNumberMap({});
      setNumberToStringMap({});
      processData()
    }

  }, [communities, itemToCommunity,edges, props.resourceid])
  const processData = () => {

    const communityId: number = itemToCommunity[props.resourceid]
    const focusedEdges: any[] = communities[communityId]

    const filtered: any = edges.filter(edge => 
      focusedEdges?.includes(edge.source) || focusedEdges?.includes(edge.target)
    );

      // Function to convert string IDs to integers
    const stringToNumber = (str: string) => {

      // if (stringToNumberMap[str] !== undefined) {
      //   return stringToNumberMap[str];
      // }

      let num = 0;
      for (let i = 0; i < str.length; i++) {
        num += str.charCodeAt(i);
      }

      // const newStringToNumberMap = { ...stringToNumberMap, [str]: num };
      // const newNumberToStringMap = { ...numberToStringMap, [num]: str };

      // setStringToNumberMap(newStringToNumberMap);
      // setNumberToStringMap(newNumberToStringMap);

      return num;
  };


    // Create a duplicate of filteredEdges with integer IDs
    const filteredEdgesWithIntIds = filtered.map((edge: any) => ({
      source: stringToNumber(edge.source),
      target: stringToNumber(edge.target),
    }));
    
    const newFilteredNumberToStringMap: any = {}
    const newFilteredStringToNumberMap: any = {}
    filtered.forEach((edge: any) => {
      newFilteredStringToNumberMap[edge.source] = stringToNumber(edge.source)
      newFilteredStringToNumberMap[edge.target] = stringToNumber(edge.target)
      newFilteredNumberToStringMap[stringToNumber(edge.source)] = edge.source
      newFilteredNumberToStringMap[stringToNumber(edge.target)] = edge.target
    });
  setFilteredEdges(filteredEdgesWithIntIds);
  setNumberToStringMap(newFilteredNumberToStringMap)
  setStringToNumberMap(newFilteredStringToNumberMap)

    
    //setFilteredEdges(filtered);
  }

  
  // Function to deeply compare two arrays of objects
  const arraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (JSON.stringify(arr1[i]) !== JSON.stringify(arr2[i])) return false;
    }
    return true;
  };

  useEffect(() => {
    if (!arraysEqual(prevFilteredEdges.current, filteredEdges)) {
    
    

    // Cleanup function to clear the graph
    const clearGraph = () => {
      d3.select(svgRef.current).selectAll("*").remove();
    };

    // Clear the graph before rendering the new one
    clearGraph();
    if (filteredEdges.length > 0) {
      //renderGraph();
      renderGraph2();
    }
    // Update the ref with the current filteredEdges
    prevFilteredEdges.current = filteredEdges;
  } else {
    updateDot()
  }
  }, [filteredEdges]);

  const onNodeClick = (d) => {

    if (props.onNodeClick){
      props.onNodeClick("http://scta.info/resource/" + numberToStringMap[d], "nodeCommunities")
    }
  }

  const updateDot = () => {
    const svg = d3.select(svgRef.current)
    
    //Reset the color of all dots to the default color (e.g., black)
    svg.selectAll("circle")
    .style("r", 5); // Change "black" to your default color

    svg.selectAll("circle")
    .filter(d => numberToStringMap[d.id] === props.resourceid)
    .style("r", 10); // Change "red" to your desired color
  }

  const renderGraph2 = () => {
    const width = 960;
    const height = 600;
    // const width = 960;
    // const height = 600;
  
    // const svg = d3.select(svgRef.current)
    //   .attr("width", width)
    //   .attr("height", height);

    const svg = d3.select(svgRef.current)
    .attr("width", "100%")
    .attr("height", "100%")
    .attr("viewBox", `0 0 ${width} ${height}`)
    .attr("preserveAspectRatio", "xMinYMin meet");
  
    const nodes = Array.from(new Set(filteredEdges.flatMap(edge => [edge.source, edge.target])), id => ({ id }));
    const links = filteredEdges.map(edge => ({ source: edge.source, target: edge.target }));


    // Define a custom color scale with 20 different colors
    const customColors = [
      "#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf",
      "#aec7e8", "#ffbb78", "#98df8a", "#ff9896", "#c5b0d5", "#c49c94", "#f7b6d2", "#c7c7c7", "#dbdb8d", "#9edae5"
    ];
    // Create a color scale
    const colorScale = d3.scaleOrdinal(customColors);
    //const colorScale = d3.scaleOrdinal(d3.schemeCategory10);

    // Create a map to store the color for each prefix
    const prefixColorMap = new Map();

    // Function to get color based on the first three characters of the node ID
    function getColor(stringid: string) {
      const prefix = stringid.substring(0, 4);
      if (!prefixColorMap.has(prefix)) {
        prefixColorMap.set(prefix, colorScale(prefixColorMap.size));
      }
      const color = prefixColorMap.get(prefix);
      return color
    }

    // // Create a zoom behavior
    // const zoom = d3.zoom()
    // .scaleExtent([0.1, 10]) // Set the zoom scale extent
    // .on("zoom", zoomed);

    // // Apply the zoom behavior to the SVG element
    // svg.call(zoom);

    // function zoomed(event) {
    //   // Use d3.event if event is undefined
    //   const currentEvent = event || d3.event;
    //   console.log("event", currentEvent);
    //   svg.attr("transform", currentEvent.transform);
    // }
  
    const simulation = d3.forceSimulation(nodes)
      .force("link", d3.forceLink(links).id(d => d.id).distance(10))
      .force("charge", d3.forceManyBody().strength(-100))
      .force("center", d3.forceCenter(480,400))
      .force("x", d3.forceX(width / 2).strength(0.1))
      .force("y", d3.forceY(height / 2).strength(0.1))
      .on("tick", ticked);
  
    function ticked() {
      svg.selectAll("circle")
        .attr("cx", d => Math.max(5, Math.min(width - 5, d.x)))
        .attr("cy", d => Math.max(5, Math.min(height - 5, d.y)));
    }
    

    const link = svg.append("g")
      .attr("class", "links")
      .selectAll("line")
      .data(links)
      .enter().append("line")
      .attr("stroke-width", 1.5)
      .attr("stroke", "black");
  
    const node = svg.append("g")
      .attr("class", "nodes")
      .selectAll("circle")
      .data(nodes)
      .enter().append("circle")
      .attr("r", 5)
      .attr('fill', (d: any) => {return getColor(numberToStringMap[d.id])}) // Set the color based on the first three characters of the ID
      //.attr("fill", "blue")
      // .call(d3.drag())
        // .on("start", dragstarted)
        // .on("drag", dragged)
        // .on("end", dragended))
      .on("click", (d) => {
          if (onNodeClick) {

            onNodeClick(d.id);
          }
        });
  
    node.append("title")
      .text(d => numberToStringMap[d.id]);
  
    simulation.on("tick", () => {
      link
        .attr("x1", d => d.source.x)
        .attr("y1", d => d.source.y)
        .attr("x2", d => d.target.x)
        .attr("y2", d => d.target.y);
  
      node
        .attr("cx", d => d.x)
        .attr("cy", d => d.y);
    });
  
    //TODO; this is really working
    function dragstarted(event, d) {
      if (!event.active) simulation.alphaTarget(0.3).restart();
       event.subject.fx = event.x;
       event.subject.fy = event.y;
    }
  //TODO; this is really working
    function dragged(event, d) {
      if (!event.active) simulation.alphaTarget(0.3).restart();
      event.subject.fx = event.x;
       event.subject.fy = event.y;
    }
  //TODO; this is really working
    function dragended(event, d) {
      if (!event.active) simulation.alphaTarget(0.3).restart();
      // if (!event.active) simulation.alphaTarget(0);
      event.fx = null;
      event.fy = null;
    }

    updateDot()
  };

  return (
    <div style={{height: "60vh", width: "100%"}}>
      <svg ref={svgRef}></svg>
    </div>
  )
}